//Receipt Listing
export const FETCH_RECEIPT_LISTING_SUCCESS = 'FETCH_RECEIPT_LISTING_SUCCESS';
export const FETCH_RECEIPT_LISTING_FAILURE = 'FETCH_RECEIPT_LISTING_FAILURE';
export const UPDATE_RECEIPT_DATA_AFTER_UPDATE = 'UPDATE_RECEIPT_DATA_AFTER_UPDATE';
export const SAVE_RECEIPT_FORM_DETAILS = 'SAVE_RECEIPT_FORM_DETAILS';
export const SAVE_ITEMS_DETAILS_IN_FORM = 'SAVE_ITEMS_DETAILS_IN_FORM';
export const RESET_SAVE_RECEIPT_DETAILS = 'RESET_SAVE_RECEIPT_DETAILS';

export const RESET = 'RESET';
